"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotaType = void 0;
var QuotaType;
(function (QuotaType) {
    QuotaType["PROJECTS_PER_YEAR"] = "PROJECTS_PER_YEAR";
    QuotaType["TRANSACTIONS_PER_PROJECT"] = "TRANSACTIONS_PER_PROJECT";
    QuotaType["USERS_PER_ORGANISATION"] = "USERS_PER_ORGANISATION";
    QuotaType["AI_ENABLED"] = "AI_ENABLED";
})(QuotaType || (exports.QuotaType = QuotaType = {}));
